import React, { useEffect, useState } from 'react';
import {
    Badge,
    Card,
    Row,
    Col,
    Container,
    Image,
} from 'react-bootstrap';
import moment from "moment";
import { convertCurrency, numberFormat, convertOrderStatus } from '../../helper';
import { GET_EXCHANGE_RATE } from '../../apollo/product/query';
import { useLazyQuery } from '@apollo/client';
import { COLOR_WHITE, imageRender } from '../../const';
import { FaLuggageCart } from 'react-icons/fa';

import noProductImg from "../../images/no_product.png";

// Helper functions (implemented locally if not in global helpers)
const convertOrderType = (type) => {
    switch (type) {
        case 'POS':
            return 'ໜ້າຮ້ານ';
        case 'ONLINE':
            return 'ອອນໄລນ໌';
        case 'LIVE':
            return 'ໄລ້ສົດ';
        default:
            return type || '-';
    }
};

const convertLogicticsName = (name) => {
    return name || "-";
};

const convertPriceWithCommission = (totalPrice, sumPriceBaht, sumPriceUsd, commission, rate) => {
    const kip = Number(totalPrice ?? 0) || 0;
    const baht = Number(sumPriceBaht ?? 0) || 0;
    const usd = Number(sumPriceUsd ?? 0) || 0;
    const extra = Number(commission ?? 0) || 0;

    const bahtRate = Number(rate?.baht) > 0 ? Number(rate?.baht) : 1;
    const usdRate = Number(rate?.usd) > 0 ? Number(rate?.usd) : 1;

    return kip + baht * bahtRate + usd * usdRate + extra;
};

export default function SalepageOrderDetail({ selectedOrderGroup }) {

    const [shopRate, setShopRate] = useState()

    const [getExchangeRate, { data: loadExchangeRate, loading: loadingExchangeRate }] = useLazyQuery(GET_EXCHANGE_RATE, { fetchPolicy: "cache-and-network" });

    useEffect(() => {
        if (loadExchangeRate) {
            setShopRate(loadExchangeRate?.exchangeRate)
        }
    }, [loadExchangeRate])

    //   fetch exchange ret
    useEffect(() => {
        if (selectedOrderGroup?.shop?.id) {
            getExchangeRate({
                variables: {
                    where: {
                        shop: selectedOrderGroup?.shop?.id,
                    },
                },
            });
        }
    }, [selectedOrderGroup]);

    if (!selectedOrderGroup) return null;
    const createdAtText = moment(selectedOrderGroup?.createdAt).isValid()
        ? moment(selectedOrderGroup?.createdAt).format("DD/MM/YYYY HH:mm")
        : (selectedOrderGroup?.createdAt ?? "-");
    console.log("selectedOrderGroup?.orders", selectedOrderGroup?.orders);
    console.log("selectedOrderGroup", selectedOrderGroup);
    
    return (
        <Container className="py-4">

            {/* Order Header */}
            <Row className="mb-4">
                <Col md={6}>
                    <h6>ລູກຄ້າ: {selectedOrderGroup?.cfName ?? selectedOrderGroup?.customerName ?? "-"}</h6>
                    <p>ເບີໂທ: {selectedOrderGroup?.phone ?? "-"}</p>
                    <p>ວັນທີ,ເດືອນ,ປີ {createdAtText}</p>
                </Col>
                <Col md={6}>
                    <p>
                        ການຊຳລະ:{" "}
                        <Badge bg={selectedOrderGroup?.isPaymented ? "success" : "danger"}>
                            {selectedOrderGroup?.isPaymented ? "ຊຳລະແລ້ວ" : "ຍັງບໍ່ຊຳລະ"}
                        </Badge>
                    </p>
                    {/* <p>ຫົວຂໍ້: {selectedOrderGroup?.live?.description ?? "-"}</p> */}
                    {/* <p>ທວງຍອດ: {selectedOrderGroup?.isClaimBalance ? "ທວງຍອດແລ້ວ" : "ຍັງບໍທວງຍອດ"}</p> */}
                    <p>ຈ່າຍຄ່າເຄື່ອງ: {selectedOrderGroup?.orderDelivery?.shipmentPayType === "COD" ? "ປາຍທາງ" : "ຕົ້ນທາງ"}</p>
                    <p>ສະຖານະອໍເດີ້: {convertOrderStatus(selectedOrderGroup?.status)}</p>
                    <p>ປະເພດ: {convertOrderType(selectedOrderGroup?.type)}</p>
                </Col>
            </Row>
            <hr />

            {/* Order Items */}
            <Card style={{ boxShadow: 'none', border: 'none', background: COLOR_WHITE }} className="mb-4">
                <Card.Body>
                    <Card.Text>
                        ລາຍການອໍເດີ້
                    </Card.Text>
                    {selectedOrderGroup?.orders?.map((item) => (
                        <Row key={item.id} className="align-items-center mb-3 border-bottom">
                            <Col md={2}>
                                <Image
                                    src={item?.stock?.image.length ? imageRender(item?.stock?.image) : noProductImg}
                                    alt={item?.cfMessage}
                                    className="img-fluid rounded"
                                    style={{ width: 60 }}
                                />
                            </Col>
                            <Col md={6}>
                                <h5>{item?.productName} </h5>
                                <p className="text-muted">ລະຫັດ: {item?.cfMessage || item?.stock?.cfMessage}</p>
                            </Col>
                            <Col md={2} className="text-end">
                                <p>{convertCurrency(item?.currency)} {numberFormat(item?.totalPrice)}</p>
                            </Col>
                            <Col md={2} className="text-end">
                                <p>ຈຳນວນ: ({item?.amount})</p>
                            </Col>
                        </Row>
                    ))}
                </Card.Body>
            </Card>

            <Row>
                {/* Delivery Information */}
                <Col md={6}>
                    <Card style={{ boxShadow: 'none' }} className="mb-4">
                        <Card.Body>
                            <h5>
                                ຂົນສົ່ງ {convertLogicticsName(
                                    selectedOrderGroup?.orderDelivery?.delivery || selectedOrderGroup?.logistic || ""
                                )}
                            </h5>
                            <p>
                                <strong>ເລກຕິດຕາມພັດສະດຸ:</strong> {selectedOrderGroup?.orderDelivery?.deliveryTackingNo ?? "-"}
                            </p>

                            {selectedOrderGroup?.orderDelivery?.id ? <p>
                                <strong>ບ່ອນຈັດສົ່ງ:</strong> ({selectedOrderGroup?.orderDelivery?.receiver?.branchCode ?? "-"}), {selectedOrderGroup?.orderDelivery?.receiver?.province}, {selectedOrderGroup?.orderDelivery?.receiver?.district},{' '}
                                {selectedOrderGroup?.orderDelivery?.receiver?.branch}
                            </p> :
                                <p>
                                    <strong>ບ່ອນຈັດສົ່ງ: {selectedOrderGroup?.destinationLogistic ?? "-"} </strong> 
                                </p>
                            }

                            <p className="text-success">
                                <FaLuggageCart style={{ fontSize: 28, marginRight: 6 }} />
                                ຂົນສົ່ງອື່ນໆ: {selectedOrderGroup?.addressCf ?? ""}
                            </p>
                        </Card.Body>
                    </Card>
                </Col>


                {/* Order Summary */}
                <Col md={6}>
                    <Card style={{ boxShadow: 'none' }}>
                        <Card.Body>
                            <h5>ຂໍ້ມູນສະຫຼູບ</h5>
                            <Row className="mb-2 text-muted">
                                <Col>ລວມກີບ:</Col>
                                <Col className="text-end">{numberFormat(selectedOrderGroup?.totalPrice ?? 0)}</Col>
                            </Row>
                            <Row className="mb-2 text-muted">
                                <Col>ລວມບາດ:</Col>
                                <Col className="text-end">{numberFormat(selectedOrderGroup?.sumPriceBaht ?? 0)}</Col>
                            </Row>
                            <Row className="mb-2 text-muted">
                                <Col>ລວມໂດລາ:</Col>
                                <Col className="text-end">{numberFormat(selectedOrderGroup?.sumPriceUsd ?? 0)}</Col>
                            </Row>
                            <Row className="mb-2 text-muted">
                                <Col>Tax:</Col>
                                <Col className="text-end">0</Col>
                            </Row>
                            <hr />
                            <Row className="fw-bold">
                                <Col>ຍອດເງິນທີ່ຈ່າຍ:</Col>
                                <Col className="text-end">{numberFormat(convertPriceWithCommission(selectedOrderGroup?.totalPrice, selectedOrderGroup?.sumPriceBaht, selectedOrderGroup?.sumPriceUsd, 0, shopRate))} ກີບ</Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>

            </Row>
        </Container>
    );
}
